import React, { useState, useEffect, useRef } from 'react';
import "mathlive"; 
import katex from 'katex';
import html2canvas from 'html2canvas';
import 'katex/dist/katex.min.css';
import './App.css';

const engineeringTabs = {
  "Lowercase Greek": [
    { label: '\\alpha', tex: '\\alpha' }, { label: '\\beta', tex: '\\beta' },
    { label: '\\gamma', tex: '\\gamma' }, { label: '\\delta', tex: '\\delta' },
    { label: '\\epsilon', tex: '\\epsilon' }, { label: '\\zeta', tex: '\\zeta' },
    { label: '\\eta', tex: '\\eta' }, { label: '\\theta', tex: '\\theta' },
    { label: '\\iota', tex: '\\iota' }, { label: '\\kappa', tex: '\\kappa' },
    { label: '\\lambda', tex: '\\lambda' }, { label: '\\mu', tex: '\\mu' },
    { label: '\\nu', tex: '\\nu' }, { label: '\\xi', tex: '\\xi' },
    { label: '\\pi', tex: '\\pi' }, { label: '\\rho', tex: '\\rho' },
    { label: '\\sigma', tex: '\\sigma' }, { label: '\\tau', tex: '\\tau' },
    { label: '\\phi', tex: '\\phi' }, { label: '\\chi', tex: '\\chi' },
    { label: '\\psi', tex: '\\psi' }, { label: '\\omega', tex: '\\omega' }
  ],
  "Uppercase Greek": [
    { label: '\\Gamma', tex: '\\Gamma' }, { label: '\\Delta', tex: '\\Delta' },
    { label: '\\Theta', tex: '\\Theta' }, { label: '\\Lambda', tex: '\\Lambda' },
    { label: '\\Xi', tex: '\\Xi' }, { label: '\\Pi', tex: '\\Pi' },
    { label: '\\Sigma', tex: '\\Sigma' }, { label: '\\Phi', tex: '\\Phi' },
    { label: '\\Psi', tex: '\\Psi' }, { label: '\\Omega', tex: '\\Omega' }
  ],
  "Engineering & Dynamics": [
    { label: '\\dot{x}', tex: '\\dot{x}' }, { label: '\\ddot{x}', tex: '\\ddot{x}' },
    { label: '\\mathcal{L}\\{f\\}', tex: '\\mathcal{L}\\{#?\\}' },
    { label: '\\int_{a}^{b}', tex: '\\int_{#?}^{#?}' },
    { label: 'Matrix', tex: '\\begin{bmatrix} #? & #? \\\\ #? & #? \\end{bmatrix}' },
    { label: '\\partial', tex: '\\frac{\\partial #?}{\\partial #?}' }
  ]
};

export default function App() {
  const [latex, setLatex] = useState("m\\ddot{x} + c\\dot{x} + kx = F_0 \\cos(\\omega t)");
  const mfRef = useRef(null);

  useEffect(() => {
    const previewElement = document.getElementById('preview');
    if (previewElement) {
      katex.render(latex, previewElement, { throwOnError: false, displayMode: true });
    }
  }, [latex]);

  const insertSymbol = (tex) => {
    if (mfRef.current) {
      mfRef.current.executeCommand(['insert', tex]);
      mfRef.current.focus();
    }
  };

  const downloadPNG = () => {
    const element = document.getElementById('preview');
    html2canvas(element, { scale: 3, backgroundColor: null }).then(canvas => {
      const link = document.createElement('a');
      link.download = `hilmybox-eq-${Date.now()}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="brand">
          <h1>Hilmybox <small>Equation Editor</small></h1>
        </div>
        <button className="primary-btn" onClick={downloadPNG}>Export PNG</button>
      </header>

      <div className="main-layout">
        <aside className="sidebar">
          <div className="scroll-content">
            {Object.entries(engineeringTabs).map(([cat, symbols]) => (
              <div key={cat} className="toolbar-group">
                <h3>{cat}</h3>
                <div className="button-grid">
                  {symbols.map(s => (
                    <button key={s.label} className="symbol-btn" onClick={() => insertSymbol(s.tex)}>
                      <span dangerouslySetInnerHTML={{ __html: katex.renderToString(s.label) }} />
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
          
          <footer className="sidebar-footer">
            <p>Powered by <a href="https://hilmybox.com" target="_blank" rel="noopener noreferrer">hilmybox.com</a></p>
            <p>© 2026 Copyright All rights reserved.</p>
          </footer>
        </aside>

        <main className="editor-workspace">
          <section className="input-section">
            <div className="section-header">
              <label>Interactive Input</label>
            </div>
            <div className="mathfield-wrapper">
              <math-field 
                ref={mfRef} 
                onInput={e => setLatex(e.target.value)}
                virtual-keyboard-mode="onfocus"
              >
                {latex}
              </math-field>
            </div>
          </section>

          <section className="preview-section">
            <label>High-Res Preview</label>
            <div className="preview-container">
              <div id="preview"></div>
            </div>
          </section>

          <section className="latex-section">
            <label>Output LaTeX Code</label>
            <div className="latex-box">
              <code>{latex}</code>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}